<template>
    <div class="animated fadeIn">        
        <b-card>
            <div slot="header">
                AR Invoice Form
                <div class="card-header-actions">
                <button  v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
                  <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                </div>
            </div>
              <b-row>
                <b-col lg="8">
                    <b-form-row>
                        <b-col lg="5">
                        <b-input-group>
                            <b-input-group-prepend><label>Invoice Number</label></b-input-group-prepend>
                            <b-form-input v-model="model.invoiceno" v-b-tooltip.hover title="EMPTY for AUTO NUMBERING"></b-form-input>
                        </b-input-group>
                        </b-col>
                        <b-col lg="7">                            
                        <b-input-group>
                            <b-input-group-prepend><span class="ml-2 pt-2 mr-1">Invoice Date</span></b-input-group-prepend>
                            <b-form-input v-model="model.invdate" type="date" @change="tanggalBerubah" :state="!$v.model.invdate.$error"></b-form-input>                                        
                            <b-input-group-prepend><span class="ml-2 pt-2 mr-1">Due</span></b-input-group-prepend>
                            <b-form-input v-model="model.invdueda" type="date" ></b-form-input>                                        
                        </b-input-group>
                        </b-col>
                    </b-form-row >                      
                    <b-input-group >
                        <b-input-group-prepend><label>Customer</label></b-input-group-prepend>
                        <b-form-input readonly v-model="model.custinfo" :state="!$v.model.custcode.$error" style="width:50% !important;"></b-form-input>
                        <b-input-group-append>
                        <b-btn variant="primary" text="Button" @click="lkuCustomerShow=true" >
                            <i class="fa fa-search"></i>
                        </b-btn>
                        </b-input-group-append>
                        <b-input-group-prepend><span class="p-2">Attention</span></b-input-group-prepend>
                        <b-form-input v-model="model.ContactFin" placeholder="u.p." ></b-form-input>                                        
                    </b-input-group>
                            <b-input-group >
                                <b-input-group-prepend><label>Sales Order#</label></b-input-group-prepend>
                                <b-form-select v-model="model.salesReff" :plain="true" :options="soItems" class="bg-warning" v-b-tooltip.hover :title="`Sales ${model.salesReff}`"></b-form-select>
                                <b-form-input v-model="model.ordernumber" style="width:30% !important;"  v-b-tooltip.hover :title="`Sales ${model.salesReff}`"></b-form-input>
                                <b-input-group-append>
                                <b-btn variant="primary" text="Button" @click="showLkuSalesOrder"  v-b-tooltip.hover :title="`Sales ${model.salesReff}`">
                                    <i class="fa fa-search"></i>
                                </b-btn>
                                </b-input-group-append>
                                <b-form-radio-group class="ml-2 mt-2" v-model="model.deffered" >
                                    <b-form-radio value="0">Invoice Actual</b-form-radio>
                                    <b-form-radio value="1">Unearned Income</b-form-radio>
                                </b-form-radio-group>
                            </b-input-group>
                    <b-input-group v-if="(user.iklan==1)">
                        <b-input-group-prepend><label>Description Line#1</label></b-input-group-prepend>
                        <b-form-input v-model="model.uraian1" :state="!$v.model.uraian1.$error" maxlength="150" placeholder="ADVERTISER" v-b-tooltip.hover title="ADVERTISER"></b-form-input>
                    </b-input-group>
                    <b-input-group v-else>
                        <b-input-group-prepend><label>Description Line#1</label></b-input-group-prepend>
                        <b-form-input v-model="model.uraian1" :state="!$v.model.uraian1.$error" maxlength="150" ></b-form-input>
                    </b-input-group>
                    <b-input-group v-if="(user.iklan==1)">
                        <b-input-group-prepend><label>Description Line#2</label></b-input-group-prepend>
                        <b-form-input v-model="model.uraian2" maxlength="150" placeholder="PRODUK atau JUDUl IKLAN" v-b-tooltip.hover title="PRODUK atau JUDUl IKLAN"></b-form-input>
                    </b-input-group>
                    <b-input-group v-else>
                        <b-input-group-prepend><label>Description Line#2</label></b-input-group-prepend>
                        <b-form-input v-model="model.uraian2" maxlength="150" ></b-form-input>
                    </b-input-group>
                    <b-form-row>
                        <b-col cols="6" >
                            <b-input-group >
                                <b-input-group-prepend><label>Invoice Amount</label></b-input-group-prepend>
                                <b-input-group-prepend>
                                <b-form-select class="input-group-text" v-model="model.matauang" :plain="true" :options="currency" :state="!$v.model.matauang.$error"></b-form-select>
                                </b-input-group-prepend>
                                <my-number class="form-control text-right" separator="," v-model="model.totalinv" :precision="2" :state="!$v.model.totalinv.$error"></my-number>
                            </b-input-group>
                        </b-col>
                        <b-col cols="6">   
                            <b-input-group>
                                <b-input-group-prepend><label style="width:165px !important;">Related to other Invoice #</label></b-input-group-prepend>
                                <b-form-input v-model="model.invoicereff" placeholder="Canceled/UnEarned Inc. Invoice"></b-form-input>
                            </b-input-group>
                        </b-col>
                    </b-form-row>
                    <b-input-group >
                        <b-input-group-prepend><label >iDocs Documents</label></b-input-group-prepend>
                        <b-input-group-prepend>
                                <span class="input-group-text" >AR INVOICE</span>
                        </b-input-group-prepend>
                        <b-form-input v-model="model.iDocsURL" placeholder="iDocs URL"></b-form-input>
                        <b-input-group-append >
                            <b-btn text="Button" @click="show_iDocs()" >
                                <i class="fa fa-search"></i>
                            </b-btn>
                        </b-input-group-append>
                        <b-input-group-append v-if="(model.iDocsURL)">
                            <b-btn text="Button" variant="success" @click="open_iDocs()" >
                                Open
                            </b-btn>
                        </b-input-group-append>
                    </b-input-group>

                </b-col>
                <b-col lg="4">
                    <v-dim :model="model" :key="updateDimHdr" ></v-dim>
                    <b-input-group >
                        <b-input-group-prepend><label>Cash Flow</label></b-input-group-prepend>
                        <b-form-input readonly v-model="model.cashflow" @keyup.13.native="showLkuCashflow('model')" ></b-form-input>
                        <b-input-group-append>
                        <b-btn text="Button" @click="showLkuCashflow('model')" id="apKodecash">
                            <i class="fa fa-search"></i>
                        </b-btn>
                        </b-input-group-append>
                    </b-input-group>
                </b-col>
              </b-row>
              <b-card no-body class="mb-1">
                <b-table
                    class="mb-0"
                    ref="tblArLines"
                    outlined striped hover small
                    style="font-size:smaller;" 
                    :items="arLines.items"
                    :fields="arLines.fields"
                    :current-page="arLines.page"
                    :per-page="arLines.limit"
                    >
                        <template v-slot:cell(index)="data">
                        {{data.index + 1}}
                        </template>
                        <template v-slot:cell(description)="data">
                            <pre>{{data.item.description}}</pre>
                        </template>
                        <template v-slot:cell(quantity)="data">
                            {{data.item.quantity}} {{data.item.unitsize}}
                        </template>
                        <template v-slot:cell(unitprice)="data">
                            <span v-if="(data.item.salesKode != 'N/A')">{{data.item.unitprice|numFormat('0,0.00')}}</span>
                        </template>
                        <template v-slot:cell(nilai)="data">
                            <span v-if="(data.item.salesKode != 'N/A')">{{data.item.nilai|numFormat('0,0.00')}}</span>
                        </template>
                        <template v-slot:cell(nilaippn)="data">
                            <span v-if="(data.item.salesKode != 'N/A')">{{data.item.nilaippn|numFormat('0,0.00')}}</span>
                        </template>
                        <template v-slot:cell(nilaidue)="data">
                            <span v-if="(data.item.salesKode != 'N/A')">{{data.item.nilaidue|numFormat('0,0.00')}}</span>
                        </template>
                        <template v-slot:cell(action)="data">
                            <div class="text-center">
                            <a href="javascript:void(0)" @click="editArLines(data.item,data.toggleDetails)">
                                <i class="fa fa-pencil"></i>
                            </a>
                            |
                            <a href="javascript:void(0)" class="text-danger" @click="delArLines(data.index)">
                                <i class="fa fa-trash"></i>
                            </a>
                            </div>
                        </template>
                    <template v-slot:row-details="row">
                    <b-card class="row-details-form">
                        <b-tabs card v-model="tabIndex">
                            <b-tab title="INVOICE ITEM DETAIL" active>
                                <b-row h-align="center">
                                    <b-col lg="6" class="pl-0">
                                        <b-input-group>
                                            <b-input-group-prepend><label>Revenue Account</label></b-input-group-prepend>
                                            <b-form-select v-model="arLinesObj.salesKode" :plain="true" :options="salesAccounts" :state="!$v.arLinesObj.salesKode.$error"></b-form-select>
                                        </b-input-group>
                                        <b-input-group>
                                            <b-input-group-prepend><label>Description</label></b-input-group-prepend>
                                            <b-form-textarea :rows="4" :max-rows="13" v-model="arLinesObj.description" :state="!$v.arLinesObj.description.$error" ></b-form-textarea>
                                        </b-input-group>
                                        <b-form-row>
                                        <b-col md="6">                            
                                            <b-input-group>
                                                <b-input-group-prepend><label>Quantity</label></b-input-group-prepend>
                                                <b-form-input v-model="arLinesObj.quantity" @change="calcPrice()" type="number" :state="!$v.arLinesObj.quantity.$error"></b-form-input>
                                            </b-input-group>
                                        </b-col>
                                        <b-col md="6">                            
                                            <b-input-group>
                                                <b-input-group-prepend><label style="width:70px; text-align:right;">Unit Size</label></b-input-group-prepend>
                                                <b-form-input v-model="arLinesObj.unitsize" ></b-form-input>
                                            </b-input-group>
                                        </b-col>
                                        </b-form-row > 
                                        <b-form-row>
                                        <b-col md="8">                            
                                            <b-input-group>
                                                <b-input-group-prepend><label>Unit price</label></b-input-group-prepend>
                                                <b-input-group-prepend>
                                                <span class="input-group-text">{{model.matauang}}</span>
                                                </b-input-group-prepend>
                                                <my-number class="form-control text-right" v-model="arLinesObj.unitprice" :precision="2" :state="!$v.arLinesObj.unitprice.$error"></my-number>
                                            </b-input-group>
                                        </b-col>
                                        <b-col md="4">
                                            <b-input-group>
                                                <b-input-group-prepend><label >Discount</label></b-input-group-prepend>
                                                <b-form-input v-model="arLinesObj.disc" ></b-form-input>
                                                <b-input-group-append><span class="input-group-text"> %</span></b-input-group-append>
                                            </b-input-group>
                                        </b-col>
                                        </b-form-row >                      

                                    </b-col>
                                    <b-col lg="6" class="pl-0"> 
                                        <b-form-row>
                                            <b-col xl="10">                            
                                                <b-input-group>
                                                    <b-input-group-prepend><label>Amount</label></b-input-group-prepend>
                                                    <b-input-group-prepend>
                                                    <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                                                    </b-input-group-prepend>
                                                    <my-number class="form-control text-right" v-model="arLinesObj.nilai" :precision="2" disabled></my-number>
                                                </b-input-group>
                                            </b-col>
                                            <b-col xl="2">                            
                                                <b-form-checkbox id="chkPrint" class="ml-1 mt-2" v-model="arLinesObj.printhide" value="1" unchecked-value="0" >No Print</b-form-checkbox>
                                            </b-col>
                                        </b-form-row >                      
                                        <b-form-row>
                                            <b-col xl="10">                            
                                                <b-input-group>
                                                    <b-input-group-prepend><label>Discount</label></b-input-group-prepend>
                                                    <b-input-group-prepend>
                                                    <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                                                    </b-input-group-prepend>
                                                    <my-number class="form-control text-right" v-model="arLinesObj.nilaidisc" :precision="2" ></my-number>
                                                </b-input-group>
                                            </b-col>
                                        </b-form-row >                      
                                        <b-form-row>
                                            <b-col xl="10">                            
                                                <b-input-group>
                                                    <b-input-group-prepend><label>Net Amount</label></b-input-group-prepend>
                                                    <b-input-group-prepend>
                                                    <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                                                    </b-input-group-prepend>
                                                    <my-number class="form-control text-right" v-model="arLinesObj.nilainett" :precision="2" disabled></my-number>
                                                </b-input-group>
                                            </b-col>
                                            <b-col xl="2">                            
                                                <b-form-checkbox id="chkPPN" class="ml-1 mt-2 text-left" v-model="arLinesObj.kenappn" value=1 unchecked-value=0 @change="calcTaxes()" :state="!$v.arLinesObj.kenappn.$error">PPN(VAT)</b-form-checkbox>
                                            </b-col>
                                        </b-form-row >                      

                                        <b-form-row v-if="(arLinesObj.kenappn==1)">
                                            <b-col xl="6">
                                                <b-input-group>
                                                    <b-input-group-prepend><label>Tarif DPP</label></b-input-group-prepend>
                                                    <b-form-input v-model="arLinesObj.dppnlain" @change="calcTaxes()"></b-form-input>
                                                    <b-input-group-append><span class="input-group-text">% </span></b-input-group-append>
                                                    <b-input-group-append><span class="pt-2"><strong> &nbsp; * Net Amount</strong> </span></b-input-group-append>
                                                </b-input-group>
                                            </b-col>
                                            <b-col xl="4">                            
                                                <b-input-group>
                                                    <b-input-group-prepend><span class="p-2">Tarif PPN</span></b-input-group-prepend>
                                                    <b-form-input v-model="arLinesObj.ppn" @change="calcTaxes()" type="number" v-b-tooltip.hover :title="arLinesObj.ppn"></b-form-input>
                                                    <b-input-group-append><span class="input-group-text">%</span></b-input-group-append>
                                                </b-input-group>
                                            </b-col>
                                        </b-form-row >         
                                        <b-form-row>
                                            <b-col xl="10">                            
                                                <b-row no-gutters>
                                                    <b-col cols="8">
                                                        <b-input-group>
                                                            <b-input-group-prepend><label>PPH akan dipotong</label></b-input-group-prepend>
                                                            <b-form-select v-model="arLinesObj.pasalpph" :plain="true" :options="lookupPPH" ></b-form-select>
                                                        </b-input-group>                                          
                                                    </b-col>
                                                    <b-col cols="4">
                                                        <b-input-group>
                                                            <b-input-group-prepend><span class="p-2">Tarif PPH</span></b-input-group-prepend>
                                                            <b-form-input v-model="arLinesObj.pph" type="number" v-b-tooltip.hover :title="arLinesObj.pph"></b-form-input>
                                                            <!-- <my-number v-model="arLinesObj.pph" :precision="2" v-b-tooltip.hover :title="arLinesObj.pph"></my-number> -->
                                                            <b-input-group-append><span class="input-group-text">%</span></b-input-group-append>
                                                        </b-input-group>
                                                    </b-col>
                                                </b-row>
                                                <b-row no-gutters>
                                                    <b-col cols="1">&nbsp;
                                                    </b-col>
                                                    <b-col cols="4">
                                                        <b-input-group>
                                                            <b-form-select style="font-size:0.78rem !important;width:158px;"  v-model="calcPPh" :plain="true" :options="calcuationPPH" ></b-form-select>
                                                        </b-input-group>
                                                    </b-col>
                                                    <b-col cols="7">
                                                        <b-input-group>
                                                            <b-input-group-prepend><span class="input-group-text" style="width:60px;">{{model.matauang}}</span></b-input-group-prepend>
                                                            <my-number class="form-control text-right" v-model="arLinesObj.nilaipph" :precision="2" :readonly="(calcPPh===1)"></my-number>
                                                        </b-input-group>                                          
                                                    </b-col>
                                                </b-row>
                                            </b-col>
                                        </b-form-row >         
                                        <!-- <b-form-row>
                                            <b-col xl="10">                            
                                                <b-input-group>
                                                    <b-input-group-prepend><label style="width: 150px !important;">Acc. Booked Sales Bundling</label></b-input-group-prepend>
                                                    <b-input-group-prepend>
                                                        <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                                                    </b-input-group-prepend>
                                                    <my-number class="form-control text-right" v-model="arLinesObj.nettSales" :precision="2" :disabled="(calcSales==0)"></my-number>
                                                </b-input-group>
                                            </b-col>
                                            <b-col xl="2">  
                                                <b-form-checkbox id="chkNettSales" class="ml-1 mt-2" v-model="calcSales" value=1 unchecked-value=0>Edit</b-form-checkbox>
                                            </b-col>
                                        </b-form-row >    -->

                                    </b-col>
                                </b-row>
                            </b-tab>
                            <b-tab title="INVOICE ITEM DIMENSION">
                                <b-row>
                                    <b-col lg="8" xl="6"  class="pl-0">
                                        <v-dim :model="arLinesObj" :key="updateDimDtl"></v-dim>
                                    </b-col>
                                </b-row>
                            </b-tab>
                        </b-tabs>
                        <b-row class="justify-content-center mt-1">
                            <div style="width:400px;">
                                <b-input-group >
                                    <b-input-group-prepend><span class="p-2">Add Line after update</span></b-input-group-prepend>
                                    <b-form-checkbox v-model="inputLineBerlanjut" :value="1" :unchecked-value="0"  class="pt-2"></b-form-checkbox>
                                    <b-input-group-append>
                                        <b-button class="btn btn-success mr-1" @click="saveArLines()">Update</b-button>
                                    </b-input-group-append>
                                    <b-input-group-append>
                                        <b-button class="btn btn-warning ml-1" @click="row.toggleDetails">Cancel</b-button>
                                    </b-input-group-append>
                                </b-input-group>
                            </div>
                        </b-row>
                    </b-card>
                    </template>                        
                </b-table>
                <b-row class="mt-1">
                    <b-col cols="5">
                        <b-row>
                            <b-button size="sm" class="ml-3" @click="addArLines" >Add Detail</b-button>                          
                            <div class="ml-2">
                                Showing {{((arLines.page - 1) * arLines.limit + 1)}}
                                to <span v-if="((arLines.page * arLines.limit)>arLines.total)">{{arLines.total}}</span>
                                    <span v-else>{{arLines.page * arLines.limit}}</span>
                                <strong> of {{arLines.total}} entries </strong>
                            </div>    
                        </b-row>                    
                    </b-col>
                    <b-col cols="2">
                            <b-input-group>
                                <b-input-group-prepend><span class="ml-4 pt-1 mr-2">Limit per page</span></b-input-group-prepend>
                                <b-form-select :options="[5, 10, 15, 20, 25]" :plain="true" v-model="arLines.limit"  style="width:80px;"/>
                            </b-input-group>
                    </b-col>
                    <b-col cols="5">
                        <b-pagination
                            align="right"
                            :total-rows="arLines.total"
                            :per-page="arLines.limit"
                            v-model="arLines.page"
                        ></b-pagination>
                    </b-col>
                </b-row>
              </b-card>    
                <b-row align-h="between" class="mt-1">
                    <b-col lg="8" xl="7">
                        <b-form-row>
                            <b-col lg="6">
                                <b-input-group>
                                    <b-input-group-prepend><label>AR Posting Group</label></b-input-group-prepend>
                                    <b-form-select v-model="model.artype" :plain="true" :options="postGroups" :state="!$v.model.artype.$error"></b-form-select>
                                </b-input-group>
                            </b-col>
                            <b-col lg="6">
                                <b-input-group>
                                    <b-input-group-prepend><label>Sales / AE</label></b-input-group-prepend>
                                    <b-form-input placeholder="Pilih Sales AE" v-model="model.accexec" ></b-form-input>
                                    <b-input-group-append>
                                    <b-btn variant="primary" text="Button" @click="lkuSalesaeShow=true" >
                                        <i class="fa fa-search"></i>
                                    </b-btn>
                                    </b-input-group-append>
                                </b-input-group>
                            </b-col>
                        </b-form-row>                      
                        <b-form-row>
                            <b-col lg="6">
                                <b-input-group >
                                    <b-input-group-prepend><label>No. Faktur Pajak</label></b-input-group-prepend>
                                    <b-form-input v-model="model.nofaktur"  v-b-tooltip.hover title="Jika dikosongkan, Sistem akan isi otomatis" placeholder="Kosongkan, u/ pengisian otomatis"></b-form-input>
                                </b-input-group>
                            </b-col>
                            <b-col xl="5" lg="6">
                                <b-input-group >
                                    <b-input-group-prepend><label >Tgl. Faktur Pajak</label></b-input-group-prepend>
                                    <b-form-input v-model="model.tglfaktur" type="date"></b-form-input>
                                </b-input-group>
                            </b-col>
                        </b-form-row>                      
                        <b-row v-if="(model.matauang !== uanguser)">
                            <b-col lg="6">
                            <b-input-group >
                                <b-input-group-prepend><label >Exch. Rate <strong>{{model.matauang}}</strong></label></b-input-group-prepend>
                                <b-input-group-prepend>
                                <span class="input-group-text" style="width:60px;">{{uanguser}}</span>
                                </b-input-group-prepend>
                                <my-number  class="form-control text-right" separator="," v-model="model.kursPPN" :state="!$v.model.kursPPN.$error"></my-number>
                            </b-input-group>
                            </b-col>
                            <b-col lg="6">
                            <b-input-group >
                                <b-input-group-prepend><label style="text-align: right !important;">Kurs Pajak <strong>{{model.matauang}}</strong></label></b-input-group-prepend>
                                <b-input-group-prepend><span class="input-group-text" style="width:60px;">{{uanguser}}</span></b-input-group-prepend>
                                    <my-number class="form-control text-right" separator="," v-model="model.kursPPN"  :state="!$v.model.kursPPN.$error"></my-number>
                                </b-input-group>
                            </b-col>
                        </b-row>                      
                        <b-row>
                            <b-col lg="7">
                                <b-input-group >
                                    <b-input-group-prepend><label>PPH akan dipotong</label></b-input-group-prepend>
                                    <b-input-group-prepend>
                                        <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                                    </b-input-group-prepend>
                                    <my-number class="form-control text-right" v-model="model.totalpph" :precision="2" disabled></my-number>
                                    <b-form-checkbox id="chkGrossUp" class="ml-1 mt-2" v-model="model.grossup" value=1 unchecked-value=0>Gross Up</b-form-checkbox>
                                </b-input-group>
                            </b-col>
                            <b-col lg="5">
                                <b-input-group >
                                    <b-input-group-prepend><label style="text-align: left;width:158px; padding-left:16px;">Bentuk Pembayaran</label></b-input-group-prepend>
                                    <b-form-select v-model="model.pack_name" :plain="true" :options="paymentForms" v-b-tooltip.hover :title="model.pack_name">
                                    </b-form-select>
                                </b-input-group>
                            </b-col>
                        </b-row>   
                        <b-input-group >
                            <b-input-group-prepend><label class="text-right" style="width:260px !important;">Payment should transfer to Bank Account</label></b-input-group-prepend>
                            <b-form-input readonly v-model="model.namabank2" @keyup.13.native="showLkuBankAccount('satu')" :state="!$v.model.kodebank.$error" style="width:16% !important;"></b-form-input>
                            <b-input-group-append>
                                <b-btn text="Button" @click="showLkuBankAccount('satu')">
                                    <i class="fa fa-search"></i>
                                </b-btn>
                            </b-input-group-append>
                            <b-input-group-prepend><span class="ml-1 pt-2 mr-1">Acc.No.</span></b-input-group-prepend>
                            <b-form-input disabled v-model="model.nomorrek"></b-form-input>
                            <b-input-group-append>
                                <span class="input-group-text" style="width:60px;">{{model.matauangbank}}</span>
                            </b-input-group-append>
                        </b-input-group>
                        <b-input-group >
                            <b-input-group-prepend><label class="text-right" style="width:216px !important;"> or to Bank Account</label></b-input-group-prepend>
                            <b-input-group-append>
                                <b-btn text="Button" @click="clearBankAccount('dua')" class="ml-2 btn btn-danger"> 
                                    <i class="fa fa-close"></i>
                                </b-btn>
                            </b-input-group-append>
                            <b-form-input readonly v-model="model.inv_bankName" @keyup.13.native="showLkuBankAccount('dua')"  style="width:16% !important;"></b-form-input>
                            <b-input-group-append>
                                <b-btn text="Button" @click="showLkuBankAccount('dua')">
                                    <i class="fa fa-search"></i>
                                </b-btn>
                            </b-input-group-append>
                            <b-input-group-prepend><span class="ml-1 pt-2 mr-1">Acc.No.</span></b-input-group-prepend>
                            <b-form-input disabled v-model="model.inv_bankAccNo"></b-form-input>
                            <b-input-group-append>
                                <span class="input-group-text" style="width:60px;">{{model.inv_bankmatauang}}</span>
                            </b-input-group-append>
                        </b-input-group>
                        <!-- <div class="text-right mt-3">
                            <button  v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
                            <button class="btn btn-primary" @click="close()" > <i class="fa fa-close"></i> Close</button>
                        </div> -->

                    </b-col>
                    <b-col lg="4">
                        <div class="text-right">
                            <b-input-group >
                                <b-input-group-prepend><label style="text-align: left; width:158px; padding-left:16px;">Gross</label></b-input-group-prepend>
                                <b-input-group-prepend>
                                    <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                                </b-input-group-prepend>
                                <my-number class="form-control text-right" v-model="model.ttlgross" :precision="2" disabled></my-number>
                            </b-input-group>
                            <b-input-group >
                                <b-input-group-prepend>
                                <b-form-select style="width:158px;"  v-model="model.calcDisc" :plain="true" :options="calcuationDisc" ></b-form-select>
                                </b-input-group-prepend>
                                <b-input-group-prepend><span class="input-group-text" style="width:60px;">{{model.matauang}}</span></b-input-group-prepend>
                                <my-number class="form-control text-right" v-model="model.ttldiskon" :precision="2" :readonly="(model.calcDisc===1)"></my-number>
                            </b-input-group>
                            <b-input-group >
                                <b-input-group-prepend><label style="text-align: left; width:158px; padding-left:16px;">Netto</label></b-input-group-prepend>
                                <b-input-group-prepend>
                                    <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                                </b-input-group-prepend>
                                <my-number class="form-control text-right" v-model="model.ttlnetto" :precision="2" disabled></my-number>
                            </b-input-group>
                            <b-input-group >
                                <b-input-group-prepend>
                                <b-form-select style="width:158px;"  v-model="model.calcVAT" :plain="true" :options="calcuationVAT" ></b-form-select>
                                </b-input-group-prepend>
                                <b-input-group-prepend><span class="input-group-text" style="width:60px;">{{model.matauang}}</span></b-input-group-prepend>
                                <my-number class="form-control text-right" v-model="model.ttlvat" :precision="2" :readonly="(model.calcVAT===1)"></my-number>
                            </b-input-group>
                            <b-input-group >
                                <b-input-group-prepend><label style="text-align: left;width:158px; padding-left:16px;">Total Amount Due</label></b-input-group-prepend>
                                <b-input-group-prepend>
                                    <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                                </b-input-group-prepend>
                                <my-number class="form-control text-right" v-model="model.ttlamtdue" :precision="2" disabled></my-number>
                            </b-input-group>
                        </div>
                    </b-col>
                </b-row>
                <b-row class="justify-content-center mb-2">
                    <div style="width:450px;" class="text-right">
                        <b-input-group >
                            <b-input-group-prepend><span class="p-2">remain on Form after save</span></b-input-group-prepend>
                            <b-form-checkbox v-model="inputBerlanjut" :value="1" :unchecked-value="0"  class="pt-2"></b-form-checkbox>
                            <b-input-group-append>
                                <button  v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
                            </b-input-group-append>
                            <b-input-group-append>
                                <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                            </b-input-group-append>
                        </b-input-group>
                    </div>
                </b-row>

        </b-card>
        <b-modal v-model="lkuCustomerShow" size="lg" :hide-footer="true" title="List of Customer" :centered="true">
            <lku-customer @click="onSelectLkuCustomer"></lku-customer>
        </b-modal>        
        <b-modal v-model="lkuCashflowShow" size="lg" :hide-footer="true" title="List of Cashflow Account" :centered="true">
                <lku-cashflow @click="onSelectLkuCashflow" :formdata="lkuCashflowData"></lku-cashflow>
        </b-modal>      
        <b-modal v-model="lkuSoShow" size="lg" :hide-footer="true" title="List of Sales Order Header"  :key="`H${model.customer_id}`" :centered="true">
            <lku-salesorder @click="onSelectLkuSo" :customer="model.custinfo" :customer_id="model.customer_id" status="111" completed="0"></lku-salesorder>
        </b-modal>        
        <b-modal v-model="lkuSolineShow" size="lg" :hide-footer="true" title="List of Sales Order Line/Item"  :key="`L${model.customer_id}`" :centered="true">
            <lku-salesorderline @click="onSelectLkuSoline" :customer="model.custinfo" :customer_id="model.customer_id" status="111"  completed="0"></lku-salesorderline>
        </b-modal>         
        <b-modal v-model="lkuSalesaeShow" size="lg" :hide-footer="true" title="List of Sales AE" :centered="true" :lazy="true">
            <lku-salesae @click="onSelectLkuSalesae"></lku-salesae>
        </b-modal> 
        <b-modal v-model="lkuBankaccountShow" size="lg" :hide-footer="true" title="List of Bank/Cash Account" :centered="true">
            <lku-bankaccount @click="onSelectLkuBankaccount" isbank="1" :formdata="lkuBankaccountData" aktif="1" ></lku-bankaccount>
        </b-modal>        
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       

    </div>
</template>
<style lang="scss">
    .input-group {
        padding-bottom:2px;
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 130px;
            }
        }
    }
    .form-group {
        margin-bottom:2px;
        .input-group {
            padding-bottom:0;
        }
    }
    .row-details-form {
        label {
        text-align: right !important;
        }
        legend {
        text-align: right !important;;
        }
      .input-group {
          .input-group-prepend {
              label {
                  width: 110px !important;
              }
          }
      }

    }
</style>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import toastr from "mini-toastr";
import moment from 'moment';
import myNumber from "../../components/my-number";
import vDim from "../lookup/dim";
import lkuBankaccount from "../lookup/lkuBankaccountLazzy";
import lkuCashflow from "../lookup/lkuCashflowLazzy";
import lkuCustomer from "../lookup/lkuCustomer";
import lkuSalesae from "../lookup/lkuSalesae";
import lkuSalesorder from "../lookup/lkuSalesOrder";
import lkuSalesorderline from "../lookup/lkuSalesOrderLine";
import arinv from "../../apis/arinv";
import dimension from "../../apis/dimension";
import { validationMixin } from "vuelidate";
import { required, decimal } from "vuelidate/lib/validators";
toastr.init();

export default {   
  components: { myNumber,  Loading, vDim, lkuBankaccount, lkuCustomer, lkuCashflow, lkuSalesorder, lkuSalesorderline, lkuSalesae},
  mixins: [validationMixin],
  validations: {
        model: {
            custcode: { required },
            uraian1: { required },
            invdate: { required },
            artype: { required },
            kodebank: { required },
            // kodecash: { required },
            matauang: { required },
            totalinv: { required },
            // kursPPN: { numeric, required:requiredUnless('localCurrency') }
            kursPPN: {required : (function() {
                if ((this.model.ttlvat || 0) == 0) {
                    this.model.kursPPN=this.model.kursPPN || 1;
                    return true;
                } else if (this.model.matauang == this.uanguser){
                    this.model.kursPPN=1;
                    return true;
                } else if ((this.model.kursPPN || 0) == 0){
                    return false;
                } else return true;
            })},
        },
        arLinesObj: {
            salesKode: { required },
            description: { required },
            quantity: { decimal },
            unitprice: { decimal },
            nilai: { decimal },
            ppn: { decimal },
            kenappn: { required },
            pph: { decimal },
        },
  }, 
  data() {
    return {
        calcSales:0,
        isLoading:false,
        saveEnabled:true,
        inputBerlanjut: 1,
        inputLineBerlanjut: 1,
        lkuCashflowData:{},
        lkuCashflowShow: false,
        lkuCashflowCaller:'model',        
        lkuCustomerShow: false,
        lkuBankaccountData:{},
        lkuBankaccountShow: false,
        lkuBankaccountCaller:'satu',
        lkuSalesaeShow: false,
        lkuSolineShow: false,        
        lkuSoShow: false,
        lkuSoData:{},
        soItems: ['Header', 'Line/item'],
        updateDimHdr:false,
        updateDimDtl:true,
        tarifPPN: this.$store.state.user.tarifppn || 10,
        tahun:(this.$store.state.user.tglaktif || '').substring(0,4),
        uanguser: this.$store.state.user.matauang,
        user: this.$store.state.user,
        postGroups:[],salesAccounts:[],bankAccount:[],
        currency:[{value:'IDR',text:'IDR'}],
        calcuationVAT : [{ value: 1, text: 'VAT (Auto Calc)' }, { value: 0, text: 'VAT (Manual Calc)' }],
        calcuationDisc : [{ value: 1, text: 'Disc (Auto Calc)' }, { value: 0, text: 'Disc (Manual Calc)' }],
        calcPPh:1,
        calcuationPPH : [{ value: 1, text: 'Nilai PPH(Auto)' }, { value: 0, text: 'Nilai PPH(Manual)' }],
        lookupPPH:[], paymentForms:[{value:'STANDARD', text: 'Standard Cash/Bank'}],
        YesNo :   [{ value: 1, text: 'YES' }, { value: 0, text: 'NO' }],
        model:{custcode: '',ordernumber:'',salesReff:'Header',
            uraian1: '',iDocsURL:'',
            invdate: moment().format('YYYY-MM-DD'),
            artype: '',
            kodebank: '',inv_bankkode:'',
            namabank2: '',inv_bankName:'',
            nomorrek: '',inv_bankAccNo:'',
            matauangbank:'', inv_bankmatauang:'',
            kodecash: '',
            matauang: 'IDR',pack_name:'STANDARD',
            nofaktur: '', tglfaktur: '',
            totalinv: 0,
            kursPPN: 1,
            nilaippn:0,ttlvat:0,deffered:0,proforma:0, 
            DimTableKey:'', ttlgross:'', ttlamtdue:'', calcVAT:1,calcDisc:1},
        arLines: {
            items: [],
            selected:{},
            fields: [
                {key: 'index', label: 'No.' ,thStyle: "width:40px"},
                {
                    key: "description",
                    label: "Description",
                },
                {
                    key: "NamaSale",
                    label: "Revenue Account"
                },
                {
                    key: "quantity",
                    label: "Quantity",
                    thStyle: "width:90px",
                },
                {
                    key: "unitprice",
                    label: "Unit price",
                    thStyle: "width:120px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "nilai",
                    label: "Amount NETT",
                    thStyle: "width:120px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "nilaippn",
                    label: "VAT",
                    thStyle: "width:100px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "nilaidue",
                    label: "Amount DUE",
                    thStyle: "width:120px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "action",
                    label: "Action",
                    thStyle: "width:60px",
                    thClass: "text-center",
                },
            ],
            page: 1,
            limit: 5,
            total: 0,
        },
        arLinesObj:{unitsize:'', 
            DimTableKey:'', 
            salesKode: '',
            description: '',
            quantity: 1,
            unitprice: 0,
            nilai: 0,
            ppn: 0,
            kenappn: 0,
            pasalpph: '',
            pph: 0,
            nilaidisc:0,
            disc:0
        },
        tabIndex:0
    };
},
  computed: {
    dimension(){
      return this.$store.state.dimension;
    },
    invalidArLines() {
      this.$v.arLinesObj.$touch();
      return this.$v.arLinesObj.$invalid;
    },
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    noPPN(){
        return (this.model.nilaippn == 0);
    },
    unitprice(){
        return this.arLinesObj.unitprice;
    },
    pasalpph(){
        return this.arLinesObj.pasalpph;
    },    
    salesKode(){
        return this.arLinesObj.salesKode;
    },    
    tarifPPh(){
        return this.arLinesObj.pph;
    },    
    disc(){
        return this.arLinesObj.disc || 0;
    },    
    discvalue(){
        return this.arLinesObj.nilaidisc;
    },    
    disctotal(){
        return this.model.ttldiskon;
    },    
    vattotal(){
        return this.model.ttlvat;
    },    
  },
  watch: {
    unitprice: function(newval) {
        // console.log('unitprice :',newval);
        // setTimeout(() => {
            this.calcPrice();
        // }, 100);
    },    
    pasalpph: function(newval) {
        const item = this.lookupPPH.find(p => p.value==newval);
        if (item) {
            this.arLinesObj.pph=item.pph;
            setTimeout(() => {
                this.calcTaxes();
            }, 100);
        }
    },    
    tarifPPh: function(newval) {
            this.calcPrice();
    },    
    disc: function(newval) {
        setTimeout(() => {
            this.arLinesObj.nilaidisc = parseFloat((this.arLinesObj.nilai || 0)) * parseFloat(this.arLinesObj.disc) / 100;;        
            this.calcTaxes();            
        }, 500);
    },    
    discvalue: function(newval) {
        setTimeout(() => {
            this.calcTaxes();            
        }, 500);
    },    
    disctotal: function(newval) {
        this.model.ttlnetto=this.model.ttlgross-this.model.ttldiskon;
        this.model.ttlamtdue = this.model.ttlnetto+this.model.ttlvat;
    },    
    vattotal: function(newval) {
        this.model.ttlamtdue = this.model.ttlnetto+this.model.ttlvat;
    },    
    salesKode: function(newval) {
        const item = this.salesAccounts.find(p => p.value==newval);
        if (item) {
            this.arLinesObj.NamaSale=item.text;
        }
        if (newval=="N/A") {
            this.arLinesObj.unitsize='';
            this.arLinesObj.quantity = 0;
            this.arLinesObj.kenappn = 0;
            this.arLinesObj.dppnlain = 100;
            this.arLinesObj.ppn = 0;
            this.arLinesObj.nilaipph = 0;
            this.arLinesObj.nilainett =0;
            this.arLinesObj.unitprice=0;
            this.arLinesObj.pasalpph='N/A';
        }
    },    
    noPPN: function(newval) {
        if (newval) {
            this.model.nofaktur='';
            this.model.tglfaktur='';
        }
    },    
    // 'model.kodebank': function (newval) {
    // //   console.log('kodebank : ', newval);
    //   const bank = this.bankAccount.find(b => b.kode==newval);
    //   if (bank) {
    //       this.model.nomorrek=bank.nomorrek;
    //       this.model.matauangbank= bank.matauang;
    //   }
    // },

  },
  created: async function(){

      if (this.$route.params.arinvKey)  {
          this.inputBerlanjut=0;
          toastr.info('Loading ARDetail, please wait')
          try {
            const [a,b,c,d,e,f,data] = await Promise.all([arinv.postgroup(),arinv.pasalpph(),arinv.currency(),arinv.salesAccount(),arinv.bankacconly(),arinv.paymentform(),arinv.detail(this.$route.params)]) ;
            this.postGroups = a;
            this.lookupPPH = b;
            this.currency = c;
            this.salesAccounts = d;
            this.bankAccount = e;
            this.paymentForms = f;
            // const data = await arinv.detail(this.$route.params);  
            const row = data[0][0];
                this.saveEnabled=(row.posting === 0);
                row.invdate = row.invdate ? moment(row.invdate).format('YYYY-MM-DD') : '';
                row.invdueda = row.invdueda ? moment(row.invdueda).format('YYYY-MM-DD') : '';
                row.tglfaktur = row.tglfaktur ? moment(row.tglfaktur).format('YYYY-MM-DD') : '';
                for (var key in row) {
                    this.model[key] = row[key];
                }
                this.arLines.items = data[1];
                this.arLines.total = this.arLines.items.length;
            if ((row.issuenote=='CANCELATION') || (row.issuenote=='REISSUE')) {
                toastr.error('Edit for this record only avlaible form menu "AR Invoice - Revision/Menu"');
                this.saveEnabled=false;
            } 
                this.calcTotalDtl();
                this.tanggalBerubah();
                this.updateDimHdr = !this.updateDimHdr;            
                toastr.clear;
          } catch (error) {
                console.log('error : ', error);
                toastr.error(JSON.stringify(error), "ERROR MESSAGE");                              
          }
      } else {
        const [a,b,c,d,e,f] = await Promise.all([arinv.postgroup(),arinv.pasalpph(),arinv.currency(),arinv.salesAccount(),arinv.bankacconly(), arinv.paymentform()]) ;
        this.postGroups = a;
        this.lookupPPH = b;
        this.currency = c;
        this.salesAccounts = d;
        this.bankAccount = e;
        this.paymentForms = f;
        this.model.kodebank= this.user.inv_bankkode || '';
        this.model.namabank2= this.user.inv_bankName || '';
        this.model.nomorrek= this.user.inv_bankAccNo || '';
        this.model.matauangbank= this.user.inv_bankmatauang || '';

        this.model.inv_bankkode=this.user.inv_bankkode2 || '';
        this.model.inv_bankmatauang=this.user.inv_bankmatauang2 || '';
        this.model.inv_bankName=this.user.inv_bankName2 || '';
        this.model.inv_bankAccNo=this.user.inv_bankAccNo2 || '';

      }
    const item = this.salesAccounts.find(p => p.value=='N/A');
    if (!(item)) {
        this.salesAccounts.push({value:'N/A', text:'Not Applicable'});
    }
  },
  methods: {
    async show_iDocs() {
        this.$show_iDocs({cat:8});
    },
    async open_iDocs() {
        this.$open_iDocs(this.model.iDocsURL, (state) => this.isLoading = state);
    },
    showLkuBankAccount(callerObj)
    {
      this.lkuBankaccountShow=true;
      this.lkuBankaccountCaller=callerObj;
    },
    clearBankAccount()
    {
        console.log('clearBankAccount');
        this.model.inv_bankkode='';
        this.model.inv_bankmatauang='';
        this.model.inv_bankName='';
        this.model.inv_bankAccNo='';
    },
    onSelectLkuBankaccount(lkuData) {
        this.lkuBankaccountData=lkuData;
        this.lkuBankaccountShow=false;
        if (this.lkuBankaccountCaller=='satu'){
            this.model.kodebank=lkuData.selected.kode;
            this.model.matauangbank=lkuData.selected.matauang;
            this.model.namabank2=lkuData.selected.namabank2 || lkuData.selected.namabank;
            this.model.nomorrek=lkuData.selected.nomorrek;
        } else {
            this.model.inv_bankkode=lkuData.selected.kode;
            this.model.inv_bankmatauang=lkuData.selected.matauang;
            this.model.inv_bankName=lkuData.selected.namabank;
            this.model.inv_bankAccNo=lkuData.selected.nomorrek;
        }
    },
    showLkuCashflow(callerObj) {
        this.lkuCashflowShow=true;
        this.lkuCashflowCaller=callerObj;
    },
    onSelectLkuCashflow(lkuData) {
        this.lkuCashflowData=lkuData;
        this.lkuCashflowShow=false;
        this[this.lkuCashflowCaller].cashflow = lkuData.selected.kodecash.trim() + ' | ' + lkuData.selected.namacash.trim();
        this[this.lkuCashflowCaller].kodecash = lkuData.selected.kodecash;
        this[this.lkuCashflowCaller].namacash = lkuData.selected.namacash;
        if ((this.model.cashflow || '') == '') {
            this.model.cashflow = lkuData.selected.kodecash.trim() + ' | ' + lkuData.selected.namacash.trim();
            this.model.kodecash = lkuData.selected.kodecash;
            this.model.namacash = lkuData.selected.namacash;
        }
        this.lkuCashflowShow=false;
    },
    calcPrice : function() {
        this.arLinesObj.nilai = parseFloat(this.arLinesObj.quantity) * parseFloat((this.arLinesObj.unitprice || 0));
        this.calcTaxes();
    },
    calcTaxes : function() {
        this.arLinesObj.nilainett = this.arLinesObj.nilai - this.arLinesObj.nilaidisc;
        this.arLinesObj.dpp = parseFloat(this.arLinesObj.nilainett) * parseFloat(this.arLinesObj.dppnlain) / 100;
        this.arLinesObj.ppn = this.arLinesObj.ppn || this.tarifPPN;
        if (this.arLinesObj.kenappn == 1) {
            this.model.grossup = 0;
            this.arLinesObj.nilaippn = (parseFloat(this.arLinesObj.ppn,0)/100) * this.arLinesObj.dpp;
        } else {
            // this.arLinesObj.dpp = 0;
            // this.arLinesObj.ppn = this.tarifPPN;
            this.arLinesObj.nilaippn = 0;
        }
        if (this.model.grossup == 1)
            this.arLinesObj.dpp = this.arLinesObj.dpp * (100 / (100 - this.arLinesObj.pph));

        this.arLinesObj.nilaidue = this.arLinesObj.nilainett + this.arLinesObj.nilaippn;
        if (this.calcPPh == 1)
            this.arLinesObj.nilaipph = this.arLinesObj.dpp * this.arLinesObj.pph / 100;
        
        this.$forceUpdate();
    },
    onSelectLkuCustomer: async function (_selected) {
        this.model.custinfo = _selected.CustName.trim()+ ' | '+_selected.CustCode.trim();
        this.model.custcode = _selected.CustCode;
        this.model.customer_id = _selected.customer_id;
        const dim = this.dimension.find(d => d.RelatedObj=='customer');
        if (dim) {
            this.model[`${dim.value}`] = _selected.CustCode;
            this.model[`${dim.value}Txt`] = _selected.CustName.trim();
            this.model[`${dim.value}Info`] = _selected.CustName.trim()+ ' | '+_selected.CustCode.trim();
        }
        this.lkuCustomerShow=false;
    },
    showLkuSalesOrder(){
        if (this.model.salesReff=='Header') {
            this.lkuSoShow=true
        } else {
            this.lkuSolineShow=true
        }
    },
     onSelectLkuSo(_selected) {
        this.lkuSoShow=false;
        this.model.salesHdrKey=_selected.salesHdrKey;
        this.model.order_id=_selected.salesHdrKey;
        this.model.ordernumber = _selected.ExtrDocNo || _selected.nomor;
        // this.model.juduliklan=_selected.uraian;
        this.model.matauang=_selected.matauang;
        this.model.pack_name=_selected.jenisbayar || this.model.pack_name;
        this.model.keteranganbayar=_selected.keteranganbayar;
        if (_selected.billtoadv==1) {
            this.model.custinfo = (_selected.advCustName || '').trim()+ ' | '+ _selected.advCustCode;
            this.model.customer_id = _selected.adv_id;
            this.model.customer_name = _selected.advCustName;
            this.model.custcode = _selected.advCustCode;        

        } else {
            this.model.custinfo = (_selected.CustName || '').trim()+ ' | '+ _selected.CustCode;
            this.model.customer_id = _selected.customer_id;
            this.model.customer_name = _selected.CustName;
            this.model.custcode = _selected.CustCode;        
        }
        this.model.uraian1=_selected.uraian1;
        this.model.uraian2=_selected.uraian2;
        if ((_selected.uraian2 || '').includes('OPI')) this.model.kontrakprd=_selected.uraian2;
        this.model.Advertiser=_selected.Advertiser;
        this.model.brand=_selected.brand;
        this.model.kategori=_selected.kategori;
        this.model.accexec=_selected.salesae_name || _selected.SalesEx;
        this.model.salesae_id=_selected.salesae_id || _selected.SalesExCode;
        this.closeArLines();
        this.arLines.items=[];
        // if ((this.user.iklan!=1) && (_selected.uraian2)) {
            // this.arLines.items.push({
            //             arinvdtKey:'', 
            //             unitsize:'', 
            //             DimTableKey:'', 
            //             salesDtlKey:'',
            //             salesKode: 'N/A',
            //             itemno:'N/A',
            //             NamaSale: '',
            //             description: _selected.uraian2,
            //             unitprice: 0
            // });
        // }

        arinv.detailsalesorder({salesHdrKey:_selected.salesHdrKey}).then(data=>{
            // const row = data[0];
            // this.dimension.forEach(dim => {
            //     if (row[`${dim.value}Txt`]) {
            //     row[`${dim.value}Info`] = row[`${dim.value}Txt`];
            //     }
            // });
            const ordLines = data[1];
            ordLines.forEach((line)=>{
                // if ((line.valinvoiced != line.nilaidue) && (line.qtyinvoiced!=line.qtyOrder)) {
                if ((line.valinvoiced != line.nilaidue) || (line.qtyinvoiced!=line.qtyOrder)) {
                        const obj={};
                        obj.arinvdtKey=''; 
                        obj.unitsize=line.unitsize; 
                        obj.DimTableKey=''; 
                        obj.salesDtlKey=_selected.salesDtlKey;
                        obj.salesKode= line.itemno;
                        obj.itemno=line.saleCrCode;
                        obj.NamaSale= line.itemname || line.saleCrName;
                        obj.description= `${line.itemname || line.saleCrName} ${line.description} ${_selected.uraian2 || ''}`;
                        obj.unitprice= line.priceOrder;
                        obj.printhide= line.printhide;
                        if (line.qtydelivered) {
                            obj.quantity= line.qtydelivered - (line.qtyinvoiced || 0);
                            obj.nilai= line.priceOrder * obj.quantity;
                            obj.nilaippn= (line.nilaippn) ? obj.nilai*0.1 : 0;
                            obj.ppn= (line.nilaippn) ? this.tarifPPN: 0
                            obj.kenappn = (line.nilaippn) ? 1: 0
                            obj.nilaidisc= (line.discOrder) ? ((line.discOrder/line.grossOrder)*obj.nilai) : 0;
                            obj.disc=line.priceDiscPc;        
                            obj.dppnlain = 100;
                            obj.nilaipph = 0;
                            obj.nilainett =obj.nilai-obj.nilaidisc;
                            obj.nilaidue = obj.nilainett+obj.nilaippn;
                            // obj.nettSales= obj.quantity * (_selected.nettSales/_selected.qtyOrder);
                            obj.nettSales = obj.nilainett
                        } else {
                                obj.quantity= line.qtyOrder;
                                obj.nilai= line.grossOrder;
                                obj.nilaippn= line.nilaippn;
                                obj.ppn= (line.nilaippn) ? this.tarifPPN: 0
                                obj.kenappn = (line.nilaippn) ? 1: 0
                                obj.nilaidisc=line.discOrder;
                                obj.disc=line.priceDiscPc;        
                                obj.dppnlain = 100;
                                obj.nilaipph = 0;
                                obj.nilainett =line.grossOrder-line.discOrder;
                                obj.nilaidue = line.nilaidue;
                                // obj.nettSales= line.nettSales
                                obj.nettSales= obj.nilainett
                        }
                        this.arLines.items.push(obj);
                        if ((line.jadwal) && (!(line.qtydelivered))) {
                            const arrJadwal=JSON.parse(line.jadwal); 
                            const itemJadwal = arrJadwal.map(jd=>{
                               return moment(jd,'YYYY-MM-DD').format("DDMMM'YY");
                            });            

                            this.arLines.items.push({
                                            arinvdtKey:'', 
                                            unitsize:'', 
                                            DimTableKey:'', 
                                            salesDtlKey:'',
                                            salesKode: 'N/A',
                                            itemno:'N/A',
                                            NamaSale: '',
                                            description: `Tgl.tayang ${itemJadwal.join(',')}`,
                                            unitprice: 0
                            });
                        }


                }
            });
            this.arLines.total=this.arLines.items.length;
                this.calcTotalDtl();
            setTimeout(() => {
                 this.model.totalinv =this.model.ttlamtdue;
            }, 500);
        }).catch(err => {
            console.log('get salesorder.detail -> ', err);
        });

        this.dimension.forEach(dim => {
            if (_selected[`${dim.value}Txt`]) {
            _selected[`${dim.value}Info`] = _selected[`${dim.value}Txt`];
            }
        });
        this.updateDimDtl2Hdr(_selected);

    },    
    onSelectLkuSoline(_selected) {
        this.lkuSolineShow=false;
        this.model.salesDtlKey=_selected.salesDtlKey;
        this.model.order_id=_selected.salesHdrKey;
        this.model.ordernumber = _selected.ExtrDocNo || _selected.nomor;
        // this.model.juduliklan=_selected.uraian;
        this.model.matauang=_selected.matauang;
        this.model.pack_name=_selected.jenisbayar || this.model.pack_name;
        this.model.keteranganbayar=_selected.keteranganbayar;
        if (_selected.billtoadv==1) {
            this.model.custinfo = (_selected.CustName || '').trim()+ ' | '+ _selected.CustCode;
            this.model.customer_id = _selected.adv_id;
            this.model.customer_name = _selected.advCustName;
            this.model.custcode = _selected.advCustCode;        

        } else {
            this.model.custinfo = (_selected.CustName || '').trim()+ ' | '+ _selected.CustCode;
            this.model.customer_id = _selected.customer_id;
            this.model.customer_name = _selected.CustName;
            this.model.custcode = _selected.CustCode;        
        }
        this.model.uraian1=_selected.uraian1;
        this.model.uraian2=_selected.uraian2;
        this.model.kontrakprd=_selected.nomoropi;

        this.model.Advertiser=_selected.Advertiser;
        this.model.brand=_selected.brand;
        this.model.kategori=_selected.kategori;
        this.model.accexec=_selected.salesae_name || _selected.SalesEx;
        this.model.salesae_id=_selected.salesae_id || _selected.SalesExCode;
        this.closeArLines();
        this.arLines.items=[];
        // if ((this.user.iklan!=1) && (_selected.uraian2)) {
            // this.arLines.items.push({
            //             arinvdtKey:'', 
            //             unitsize:'', 
            //             DimTableKey:'', 
            //             salesDtlKey:'',
            //             salesKode: 'N/A',
            //             itemno:'N/A',
            //             NamaSale: '',
            //             description: _selected.uraian2,
            //             unitprice: 0
            // });
        // }

        const obj={};
        obj.arinvdtKey=''; 
        obj.unitsize=_selected.unitsize; 
        obj.DimTableKey=''; 
        obj.salesDtlKey=_selected.salesDtlKey;
        obj.salesKode= _selected.itemno;
        obj.description= _selected.description;
        obj.unitprice= _selected.priceOrder;
        obj.printhide= line.printhide;
        if (_selected.qtydelivered) {
            obj.quantity= _selected.qtydelivered - (_selected.qtyinvoiced || 0);
            obj.nilai= _selected.priceOrder * obj.quantity;
            obj.nilaippn= (_selected.nilaippn) ? obj.nilai*0.1 : 0;
            obj.ppn= (_selected.nilaippn) ? this.tarifPPN: 0
            obj.kenappn = (_selected.nilaippn) ? 1: 0
            obj.nilaidisc= (_selected.discOrder) ? ((_selected.discOrder/_selected.grossOrder)*obj.nilai) : 0;
            obj.disc=_selected.priceDiscPc;        
            obj.dppnlain = 100;
            obj.nilaipph = 0;
            obj.nilainett =obj.nilai-obj.nilaidisc;
            obj.nilaidue = obj.nilainett+obj.nilaippn;
            // obj.nettSales= obj.quantity * (_selected.nettSales/_selected.qtyOrder);
            obj.nettSales = obj.nilainett;
        } else {
            obj.quantity= _selected.qtyOrder;
            obj.unitprice= _selected.priceOrder;
            obj.nilai= _selected.grossOrder;
            obj.nilaippn= _selected.nilaippn;
            obj.ppn= (_selected.nilaippn) ? this.tarifPPN: 0
            obj.kenappn = (_selected.nilaippn) ? 1: 0
            obj.nilaidisc=_selected.discOrder;
            obj.disc=_selected.priceDiscPc;        
            obj.dppnlain = 100;
            obj.nilaipph = 0;
            obj.nilainett =_selected.grossOrder-_selected.discOrder;
            obj.nilaidue = _selected.nilaidue;     
            // obj.nettSales= line.nettSales
            obj.nettSales = obj.nilainett;
        }
        const salesAccount = this.salesAccounts.find(s => s.value==_selected.itemno)
        if (salesAccount) {
            obj.NamaSale=salesAccount.text;
            obj.itemno=salesAccount.saleCrCode;
        }
        obj.description= `${obj.NamaSale} ${obj.description} ${_selected.uraian2 || ''}`;

        this.arLines.items.push(obj);

        if ((_selected.jadwal) && (!(_selected.qtydelivered))) {
            const arrJadwal=JSON.parse(_selected.jadwal); 
            const itemJadwal = arrJadwal.map(jd=>{
               return moment(jd,'YYYY-MM-DD').format("DDMMM'YY");
            });            
            this.arLines.items.push({
                            arinvdtKey:'', 
                            unitsize:'', 
                            DimTableKey:'', 
                            salesDtlKey:'',
                            salesKode: 'N/A',
                            itemno:'N/A',
                            NamaSale: '',
                            description: `Tgl.tayang ${itemJadwal.join(',')}`,
                            unitprice: 0
            });
        }


        this.calcTotalDtl();
            setTimeout(() => {
                 this.model.totalinv =this.model.ttlamtdue;
            }, 500);

        // this.arLines.total=this.arLines.items.length;
        //     this.dimension.forEach(dim => {
        //         if (_selected[`${dim.value}Txt`]) {
        //         this.model[`${dim.value}`] = _selected[`${dim.value}`];
        //         this.model[`${dim.value}Txt`] = _selected[`${dim.value}Txt`];
        //         this.model[`${dim.value}Info`] = _selected[`${dim.value}Txt`];
        //         }
        //     });
        // this.updateDimDtl2Hdr(_selected);

    },    
    onSelectLkuSalesae: async function (_selected) {
      this.model.SalesEx = _selected.salesae_id.trim() + ' | ' + _selected.salesae_name.trim();
    //   this.model.SalesEx = _selected.salesae_name.trim();
      this.model.accexec = _selected.salesae_name.trim();
      this.model.salesae_id = _selected.salesae_id;
      this.lkuSalesaeShow=false;
    },  
    closeArLines: function(){
        const opened= this.arLines.items.find( r=> r._showDetails==true);
        if (opened) opened._showDetails=false;
    },
    addArLines : function () {
        this.closeArLines();
        this.tabIndex=0;
        const obj={_showDetails:true};
        this.arLines.selected = obj;
        // for (var key in this.arLinesObj) {
        //     this.arLinesObj[key] = '';
        // }
        this.arLinesObj.arinvdtKey=''; 
        this.arLinesObj.unitsize=''; 
        this.arLinesObj.DimTableKey=''; 
        this.arLinesObj.salesKode= '';
        this.arLinesObj.description= '';
        this.arLinesObj.quantity= 1;
        this.arLinesObj.unitprice= 0;
        this.arLinesObj.nilai= 0;
        this.arLinesObj.ppn= this.tarifPPN;
        this.arLinesObj.nilaidisc=0;
        this.arLinesObj.disc=0;        
        this.arLinesObj.unitsize='EACH';
        this.arLinesObj.quantity = 1;
        this.arLinesObj.unitprice=0;
        this.arLinesObj.dppnlain = 100;
        this.arLinesObj.ppn = this.tarifPPN;
        this.arLinesObj.nilaipph = 0;
        this.arLinesObj.nilainett =0;
        this.calcPPh=1;
        this.updateDimHdr2Dtl(this.arLinesObj);
        this.arLines.items.push(obj);
        this.arLines.total=this.arLines.items.length;
        setTimeout(() => {
                const bfore = this.arLines.page;
                const after =Math.ceil((this.arLines.total)/this.arLines.limit);
                if (bfore != after){
                    this.arLines.page =  after;                 
                    toastr.info(`Move to page ${after} of total  ${this.arLines.total} items`,'Line/Detail',10000);
                }
        }, 100);    
        this.inputLineBerlanjut=1;
    },
    editArLines : function (obj,callback) {
        this.closeArLines();
        this.arLines.selected = obj;
        // for (var key in this.arLinesObj) {
        //     this.arLinesObj[key] = '';
        // }
            this.arLinesObj.unitsize=''; 
            this.arLinesObj.DimTableKey=''; 
            this.arLinesObj.salesKode= '';
            this.arLinesObj.description= '';
            this.arLinesObj.quantity= 1;
            this.arLinesObj.unitprice= 0;
            this.arLinesObj.nilai= 0;
            this.arLinesObj.ppn= this.tarifPPN;
            this.arLinesObj.kenappn= 0;
            this.arLinesObj.pasalpph= '';
            this.arLinesObj.pph= 0;
            this.arLinesObj.nilaidisc=0;
            this.arLinesObj.disc=0;        
        for (var key in obj) {
            this.arLinesObj[key] = obj[key];
        }

        this.dimension.forEach((dim) => {
            if (obj[dim.value]) {
                this.arLinesObj[dim.value] = obj[dim.value];
                this.arLinesObj[`${dim.value}Txt`] = obj[`${dim.value}Txt`];
                this.arLinesObj[`${dim.value}Info`] = obj[dim.value] + ' | '+ obj[`${dim.value}Txt`];
            }
        });
        this.tabIndex=0;
        this.inputLineBerlanjut=0;
        callback();
    },
    delArLines: function (index) {
        if (index > -1) {
            // this.arLines.items.splice(index, 1);
            const posisi = (this.arLines.page-1)*this.arLines.limit;
            this.arLines.items.splice(posisi+index, 1);
        }
        this.arLines.total=this.arLines.items.length;
        this.calcTotalDtl();
    },
    saveArLines: async function (callback) {
        this.arLinesObj.pasalpph= this.arLinesObj.pasalpph || 'N/A';
        this.calcPrice();
        if (this.invalidArLines) {
            const invalidobj={};
            for (var key in this.$v.arLinesObj) {
            if (this.$v.arLinesObj[key].$anyError) {
                if (this.$v.arLinesObj[key].$anyError==true) invalidobj[key] = this.$v.arLinesObj[key];
            }
            }        
            console.log('validation model: ', this.arLinesObj);
            console.log('validation field: ', invalidobj);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
       } else {
           if (this.tabIndex==0) {
                for (var key in this.arLinesObj) {
                    this.arLines.selected[key] = this.arLinesObj[key];
                }
                this.calcTotalDtl();
               this.tabIndex=1;
               return
           }
            let datadim=this.arLinesObj;
            datadim.TableName = 'arinvdt';
            try {
                const dimValResult = await dimension.validate(datadim);
                if (dimValResult.success) {
                    for (var key in this.arLinesObj) {
                        this.arLines.selected[key] = this.arLinesObj[key];
                    }
                    this.arLines.selected.calcPPh= this.calcPPh;
                    this.dimension.forEach((dim) => {
                        if (datadim[dim.value]) {
                            this.arLines.selected[dim.value] = datadim[dim.value];
                            this.arLines.selected[`${dim.value}Txt`] = datadim[`${dim.value}Txt`];
                        }
                    });
                    this.arLines.total=this.arLines.items.length;
                    this.updateDimDtl2Hdr(datadim);
                    this.calcTotalDtl();
                    this.arLines.selected._showDetails=false;
                    if (callback) callback();
                if (this.inputLineBerlanjut==1) {
                    this.addArLines();
                    this.$v.arLinesObj.$reset();
                }

                } else {
                    console.log('dimValResult : ', dimValResult);
                    var msg = dimValResult.message;
                    if (callback) callback(new Error(msg));
                    else {
                        toastr.error(msg, "ERROR MESSAGE",10000);
                    }
                }
            } catch (error) {
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }        
            }
        }
    },
    save: async function () {
        console.log('Save Clicked');
        if (!this.saveEnabled) {
            toastr.error('View mode cannot be Saved');
            return;
        }
        this.isLoading=true;            
        if (((this.model.ttlvat || 0) !== 0) && ((this.model.nofaktur || '')=='')) {
            toastr.info('[No.Faktur Pajak] akan diisi otomatis jika NSFP(E-NoFa) sudah diisi', "Modul TAX Admin",10000);
        } 

        if (this.invalidModel) {
            const invalidobj={};
            for (var key in this.$v.model) {
            if (this.$v.model[key].$anyError) {
                if (this.$v.model[key].$anyError==true) invalidobj[key] = this.$v.model[key];
            }
            }        
            console.log('validation model: ', this.model);
            console.log('validation field: ', invalidobj);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
            this.isLoading=false;            
        } else if (Math.abs(this.model.totalinv - parseFloat(this.model.ttlamtdue))>0.5)  {
            toastr.error('[Total Invoice] not Balance with [Total Detail Invoice]', "ERROR MESSAGE",10000);
            this.isLoading=false;            
        } else {
            try {
                this.model.TableName = 'arinvtt';
                const dimValResult = await dimension.validate(this.model);
                if (dimValResult.success) {
                    // this.model.DimTableKey = diisi dari PO;
                    this.model.arinvKey = this.model.arinvKey || '';
                    this.model.invoiceno = this.model.invoiceno || '';
                    const row = {};
                    for (var key in this.model) {
                        row[key] = this.model[key];
                    }
                    row.invdate = moment(row.invdate).format('YYYY-MM-DD');
                    row.invdueda = (row.invdueda) ? moment(row.invdueda).format('YYYY-MM-DD'):row.invdate ;
                    row.tglfaktur = row.tglfaktur ? moment(row.tglfaktur).format('YYYY-MM-DD') : undefined;
                    
                    let lineno=1;
                    let newArLines = this.arLines.items.reduce((newArr, item) => {
                        if ((item.salesKode || '') != '') {
                            item.lineno = lineno;
                            newArr.push(item);
                            lineno += 1;
                        }
                        return newArr;
                    }, []);

                    row.lines = newArLines;
                    const hasil= await arinv.insert(row);
                    toastr.success(`Success, Trx.Number ${hasil.invoiceno}`, "Save AR Invoice",10000);

                    if (this.inputBerlanjut==0){
                        this.close();
                    } else {
                        this.isLoading=false;            
                        const invdate = this.model.invdate;
                        for (var key in this.model) {
                            this.model[key] = '';
                        }
                        this.model.invdate = invdate;
                        this.model.matauang= this.$store.state.user.matauang;
                        this.model.matauang= this.uanguser
                        this.model.pack_name='STANDARD'
                        this.model.totalinv= 0;
                        this.model.kursPPN= 1;
                        this.model.nilaippn=0;
                        this.model.ttlvat=0;
                        this.model.deffered=0;
                        this.model.proforma=0; 
                        this.model.ttlgross=0; 
                        this.model.ttlamtdue=0; 
                        this.model.calcVAT=1;
                        this.model.calcDisc=1;

                        // this.model.invdate = moment().format('YYYY-MM-DD');
                        this.arLines.items = [];
                        this.arLines.total=0;
                        this.calcTotalDtl();
                        this.$v.model.$reset();
                    }

                } else {
                    this.isLoading=false;            
                    console.log('dimValResult : ', dimValResult);
                    var msg = dimValResult.message || 'Dimension validation error';
                    toastr.error(msg, "ERROR MESSAGE",10000);
                }

            } catch (error) {
                this.isLoading=false;            
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }        
            }

        }
    },
    updateDimDtl2Hdr: function (dimDtl) {
        var dimHdr = this.model;
        this.dimension.forEach((dim) => {
            if ((dimDtl[dim.value]) && !(dimHdr[dim.value])) {
                dimHdr[dim.value] = dimDtl[dim.value];
                dimHdr[`${dim.value}Txt`] = dimDtl[`${dim.value}Txt`];
                dimHdr[`${dim.value}Info`] = dimDtl[`${dim.value}Info`] ;
            }
        });
        this.updateDimHdr = !this.updateDimHdr;
    },
    updateDimHdr2Dtl: function (dimDtl) {
        var dimHdr = this.model;
        dimDtl = dimDtl || this.arLinesObj;
        this.dimension.forEach((dim) => {
            if ((dimHdr[dim.value]) && !(dimDtl[dim.value])) {
                dimDtl[dim.value] = dimHdr[dim.value];
                dimDtl[`${dim.value}Txt`] = dimHdr[`${dim.value}Txt`];
                dimDtl[`${dim.value}Info`] = dimHdr[`${dim.value}Info`] ;
            }
        });
        this.updateDimDtl = !this.updateDimDtl;
    },
    calcTotalDtl: function () {
        // console.log('calcVAT & calcDisc : ',[this.model.calcVAT, this.model.calcDisc]);
        // this.model.calcVAT = this.model.calcVAT || 1;
        // this.model.calcDisc = this.model.calcDisc || 1;
        let nilaidpp = 0;
        let ttlvat = 0;
        let ttlgross = 0;
        let ttldiskon = 0;
        // let ttlamtdue = 0;
        let totalpph = 0;
        let totaldpp = 0;
        this.arLines.items.forEach( function (trx) {
            if (trx.kenappn==1) {
                trx.dpp=trx.nilainett;
            }
            if (trx.salesKode) {
                nilaidpp += (trx.dpp || 0);
                ttlgross += (trx.nilai || 0);
                ttldiskon += (trx.nilaidisc || 0);
                ttlvat += (trx.nilaippn || 0);
                // ttlamtdue = ttlnetto + (nilaippn || 0);
                totalpph += parseFloat(trx.nilaipph || 0);
            }
        });
        this.model.ttlgross = ttlgross;
        if (this.model.calcVAT == 1){
            this.model.nilaidpp = nilaidpp;
            this.model.ttlvat = ttlvat;
        }
        if (this.model.calcDisc == 1){
            this.model.ttldiskon = ttldiskon;
        }
        this.model.ttlnetto =this.model.ttlgross-this.model.ttldiskon;
        this.model.ttlamtdue = this.model.ttlnetto+this.model.ttlvat;
        this.model.totalpph = totalpph;
    },
    tanggalBerubah: function(){
        this.tahun=moment(this.model.invdate).format('YYYY');
    },
    close(){
    //   if ((this.$store.state.prevRoute.name) && (this.$store.state.prevRoute.name !== 'receivable.arinvfrm')) {
        // router.push({name:this.$store.state.prevRoute.name});
      if (this.$store.state.prevRoute.name) {
        router.push({name : 'receivable.arinv'});
      } else {
          router.push("home");
      }
    },

  }
};
</script>
